module.exports = __webpack_public_path__ + "static/media/etenders_main_banner.c730acc5.jpg";